import { useSearch } from '../../../hooks/context';

const useHeader = () => {
  const { header } = useSearch();

  return header;
};

export default useHeader;
